import { AiFillGithub, AiOutlineInstagram, AiOutlineTwitter } from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';

const FooterComponent = () => {
    return (
        <div className="bg-midnight w-full h-full md:h-[150px] py-[15px] md:py-0 px-[30px] gap-[30px] flex flex-col md:flex-row items-center">
            <div className="basis-[20%]">
                <h1 className="font-poppins text-white text-3xl lg:text-4xl tracking-[0.2rem] font-[500]">mazstar.</h1>
            </div>
            <div className="flex-1 ">
                <p className="md:text-[12px] text-center lg:text-left lg:text-[16px] font-poppins text-ash tracking-[0.01rem]">
                    Copyright © 2022 All Rights Reserved by mazstar.
                </p>
            </div>
            <div className="footer-icon-con">
                <a href='https://github.com/Mazstar04'><AiFillGithub/></a>
                <a href='https://ng.linkedin.com/in/mazeedah-hamzat-67394022b'><FaLinkedinIn/></a>
                <a href='https://www.instagram.com/i_am_mazstar/'><AiOutlineInstagram/></a>
                <a href='https://twitter.com/i_am_mazstar'><AiOutlineTwitter/></a>
            </div>
        </div>
    );
}

export default FooterComponent;